import React from 'react'
import styles from './code_box.module.css'
import { Grid } from '@material-ui/core'
import strings from '../../strings/strings.json'

export default function CodeBox(props) {


    const checkSevirityColor = () => {
        if (props.is_lib)
            return "bg-blue-400"
        else if (props.num >= 4)
            return 'bg-red-400'

        return 'bg-orange-400'

    }

    const codeContentHandler = (code, index) => {

        return (
            <div key={index} dir="ltr" className={`${styles.box_container} englishIranSans`}>
                {
                    code.codes.map((codes, index) => {
                        return (
                            <div key={index} className={styles.code_container}>
                                <div className={index === (code.line - 1) ? `${checkSevirityColor()} text-white rounded px-1` : 'primary_color'}>
                                    {codes}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    return (
        <div>
            <div className={`${styles.vulnerName_container} flex justify-between`}>
                <div className={`${styles.insecureCode} primary_color`}>{strings.fileDetail_insecureCode}</div>
                <div className={`${styles.vulnerName} secondry_color font-bold`}>{props.vulnerName}</div>
            </div>
            <div>
                <span>{props.data.map(codeContentHandler)}</span>
            </div>
        </div>
    )
}



